module.exports = __webpack_public_path__ + "img/e_1_2_g.92e0f15d.png";